<template>
  <draggable-options
    id="draggable-options"
    :field="field"
    :supported-languages="supportedLanguages"
    :read-only="readOnly"
    :is-wrapped="true"
    @errors="handleErrors"
    @updated="refreshPreview"
  ></draggable-options>
</template>
<script>
import langMixin from '../../../lib/components/Translations/mixins/lang-mixin.js';
import DraggableOptions from '../../entry-form/Configuration/DraggableOptions';
import $ from 'jquery';

export default {
  components: { DraggableOptions },
  mixins: [langMixin],
  props: {
    field: {
      type: Object,
      required: true
    },
    supportedLanguages: {
      type: Array,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleErrors(hasErrors) {
      $(':submit').prop('disabled', hasErrors);
    },
    refreshPreview() {
      $('#internal-value-options').trigger('change.preview');
    }
  }
};
</script>
